import React, { createContext, ReactNode, useCallback, useContext, useState } from "react";

interface BreadcrumbsContextType {
  section: string;
  setSection: (section: string) => void;
  sectionPath: string;
  setSectionPath: (path: string) => void;
  page: string;
  setPage: (page: string) => void;
}

const BreadcrumbsContext = createContext<BreadcrumbsContextType | undefined>(undefined);

interface BreadcrumbsProviderProps {
  children: ReactNode;
}

export const BreadcrumbsProvider = ({ children }: BreadcrumbsProviderProps) => {
  const [section, setSectionState] = useState<string>("");
  const [sectionPath, setSectionPath] = useState<string>("");
  const [page, setPage] = useState<string>("");

  const setSection = useCallback((value: string) => {
    setSectionState(value);
    setSectionPath("");
  }, []);

  return (
    <BreadcrumbsContext.Provider value={{ section, setSection, sectionPath, setSectionPath, page, setPage }}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};

export const useBreadcrumbs = (): BreadcrumbsContextType => {
  const context = useContext(BreadcrumbsContext);
  if (!context) {
    throw new Error("useBreadcrumbs must be used within a BreadcrumbsProvider");
  }
  return context;
};
